var LISTING = {
  all_items: [],
  all_items_header: 0,
  regions: [],
  types: [],
  experiences: [],
  orderBy: null,
  items_per_page: 12,
  page: 0,
  hb_template: null,
  items: [],
  vectorLayer: null,
  features: [],
  previousSelectedFeature: null,

  init: function(geolocate = true) {
    this.registerHelpers();
    this.setupCheckboxListeners();
    LISTING.all_items = items;

    // console.log(
    //   "🚀 ~ file: listing.js:19 ~ LISTING.all_items:",
    //   LISTING.all_items
    // );
    LISTING.all_items.map((i) => {
      if (i.price != "") i.price = parseInt(i.price);
    });

    if (typeof(items_header) != 'undefined') {
      if(items_header){
        LISTING.all_items_header = 2;
      }
    }

    this.setupOSMMap(geolocate);

    $item = "";
    var templateHtml = $("#item-template").data('html');
    LISTING.hb_template = Handlebars.compile(templateHtml);
    LISTING.searchItems();
  },
  registerHelpers: function() {
    Handlebars.registerHelper("for", function(n, block) {
      var accum = "";
      for (var i = 0; i < n; ++i) accum += block.fn(i);
      return accum;
    });

    Handlebars.registerHelper("contains", function(needle, haystack, options) {
      // por algum motivo fazer haystack.map(parseInt) devolve um NaN às vezes ?! #blackmagic
      console.log("haystack: ", haystack, needle, options);
      if (typeof haystack === "object") {
        haystack = Object.values(haystack);
      }

      if (
        Array.isArray(haystack) &&
        haystack.map((i) => parseInt(i)).indexOf(parseInt(needle)) > -1
      ) {
        return options.fn(this);
      } else {
        return options.inverse(this);
      }
    });
  },
  searchItems: function() {
    // var regions = this.getCheckboxValues("regions[]");
    // var types = this.getCheckboxValues("types[]");

    LISTING.items = LISTING.all_items;
    if (LISTING.orderBy != null) {
      switch (LISTING.orderBy) {
        case "proximity":
          LISTING.items = _.sortBy(LISTING.items, [
            function(item) {
              var coordinates = item.coordinate.split(",");
              return ol.sphere.getDistance(
                [coordinates[1], coordinates[0]],
                APP.currentLocation
              );
            },
          ]);
          break;
        case "experiences_count":
          LISTING.items = _.orderBy(LISTING.items, LISTING.orderBy, ["desc"]);
          break;
        case "price":
          LISTING.items = _.orderBy(LISTING.items, LISTING.orderBy);
          break;
      }
    }

    if (LISTING.regions.length > 0) {
      LISTING.items = LISTING.items.filter((i) => {
        console.log(i);
        if (i.region && i.region.id) {
          console.log(i.region.id, LISTING.regions.includes(i.region.id));
          if (LISTING.regions.includes(i.region.id)) return i;
        } else if (i.winerie && i.winerie.region != "" && i.winerie.region.id) {
          if (LISTING.regions.includes(i.winerie.region.id)) {
            return i;
          }
        }
      });
    }

    if (LISTING.types.length > 0) {
      LISTING.items = LISTING.items.filter((item) => {
        for (let i = 0; i < LISTING.types.length; i++) {
          if (item[LISTING.types[i]] == 1) return true;
        }
        return false;
      });
    }

    if (LISTING.experiences.length > 0) {
      //console.log(LISTING.experiences);
      LISTING.items = LISTING.items.filter((item) => {
        if (item.experience_ids) {
          let res = false;
          if (item.experience_ids) {
            let arrTmp = item.experience_ids;
            console.log(":", arrTmp);
            if (typeof arrTmp === "object") {
              arrTmp = Object.values(arrTmp);
            }
            res = LISTING.experiences.some((e) => arrTmp.includes(parseInt(e)));
          }

          if (res) return item;
        } else {
          console.log("# ", item.type.id);
          if (LISTING.experiences.includes(item.type.id)) return item;
        }
      });
    }

    if ($("input[name='winery-name']").length) {
      let wineryName = $("input[name='winery-name']")
        .val()
        .trim()
        .toLowerCase();
      //console.log("🚀 ~ file: listing.js:130 ~ wineryName:", wineryName);
      if (wineryName.length >= 2) {
        LISTING.items = LISTING.items.filter((item) => {
          if (item.name.toLowerCase().includes(wineryName)) return item;
          if (
            item.search_name
              .toLowerCase()
              .includes(wineryName.replace(/[^\w]/g, ""))
          )
            return item;

          if (
            item.adega &&
            typeof item.adega.name !== "undefined" &&
            item.adega.name.toLowerCase().includes(wineryName)
          )
            return item;
        });
      }
    }

    const city = $("#city option:selected");
    if (city.attr("data-lon")) {
      const radius = Number($("#radius option:selected").val());

      LISTING.items = LISTING.items.filter((item) => {
        var coordinates = item.coordinate.split(",");
        var distance = ol.sphere.getDistance(
          [coordinates[1], coordinates[0]],
          [city.attr("data-lon"), city.attr("data-lat")]
        );
        //console.log(distance, radius);
        if (distance < radius * 1000) return true;
        else return false;
      });
    }

    LISTING.reset();
    LISTING.loadMore();
    $("#count-results").text(LISTING.items.length);
    if (LISTING.items.length == 0) {
      $(".section-product-listing .data-table").html(
        '<div class="no-results">' + TOKEN.NO_RESULTS + "</div>"
      );
    }
  },
  getCheckboxValues: function(name, isString) {
    if (!isString) isString = false;

    return $("input[name='" + name + "']:checked")
      .map(function() {
        if (isString) return $(this).val();
        else return parseInt($(this).val());
      })
      .get();
  },
  setupCheckboxListeners: function() {
    $(".filter-bar .checkbox input").change(function() {
      LISTING.changeFilterRegion();
    });
    LISTING.changeFilterRegion();
  },
  changeFilterRegion: function() {
    LISTING.regions = LISTING.getCheckboxValues("regions[]");
    $("#regions-counter").text(
      LISTING.regions.length > 0 ? "(" + LISTING.regions.length + ")" : ""
    );
    LISTING.types = LISTING.getCheckboxValues("types[]", true);
    $("#types-counter").text(
      LISTING.types.length > 0 ? "(" + LISTING.types.length + ")" : ""
    );

    LISTING.experiences = LISTING.getCheckboxValues("experiences[]");
    $("#experiences-counter").text(
      LISTING.experiences.length > 0
        ? "(" + LISTING.experiences.length + ")"
        : ""
    );
  },

  loadMore: function() {
    var items = LISTING.items;
    if (LISTING.all_items_header > 0){ 
      this.loadHeader();
      items = LISTING.items.slice(LISTING.all_items_header);
    }

    for (
      let i = LISTING.page * LISTING.items_per_page;
      i < (LISTING.page + 1) * LISTING.items_per_page &&
      i < items.length;
      i++
    ) {
      $(".section-product-listing .data-table").append(
        LISTING.hb_template(items[i])
      );
    }
    LISTING.page++;
    if (items.length / LISTING.items_per_page <= LISTING.page) {
      $("#view-more").addClass("is-hidden");
    } else {
      $("#view-more").removeClass("is-hidden");
    }
  },

  loadHeader: function() {
    var items = LISTING.items.slice(0, LISTING.all_items_header);
    $(".section-product-listing .tx-special__products").html("");
    for (let i = 0; i < items.length; i++) {
      $(".section-product-listing .tx-special__products").append(
        LISTING.hb_template(items[i])
      );
    }
  },

  getStyle(style) {
    switch (style) {
      case "default":
        return new ol.style.Style({
          image: new ol.style.Icon({
            src: "assets/images/pin-map.png",
            anchor: [0.5, 1],
            scale: 0.4,
            color: "#c52973",
          }),
        });
      case "selected":
        return new ol.style.Style({
          image: new ol.style.Icon({
            src: "assets/images/pin-map.png",
            anchor: [0.5, 1],
            scale: 0.4,
            color: "#32bb7c",
          }),
        });
      default:
        return new ol.style.Style(null);
    }
  },

  reset: function() {
    $(".section-product-listing .data-table").html("");
    LISTING.previousSelectedFeature = null;
    $("#popup").hide();
    LISTING.page = 0;
    var style = LISTING.getStyle("default");
    var nullStyle = LISTING.getStyle(null);
    var filteredItemsId = LISTING.items.map((i) => i.id);

    for (var index = 0; index < LISTING.features.length; index++) {
      const f = LISTING.features[index];
      if (filteredItemsId.includes(f.id)) {
        f.feature.setStyle(style);
      } else {
        f.feature.setStyle(nullStyle);
      }
    }
  },

  changeView: function(el, type) {
    localStorage.setItem("view", type);
    $(".view-by-selector .button").removeClass("is-secondary is-selected");
    $(el).addClass("is-secondary is-selected");
    if (type == "map") {
      $(".list-tiles-container").addClass("is-hidden");
      $(".tx-special__wrapper").addClass("is-map");

      $(".osm-map").removeClass("is-hidden");
      $(".order-by-selector").addClass("is-hidden");
      APP.map.updateSize();
    } else {
      $(".order-by-selector").removeClass("is-hidden");
      $(".list-tiles-container").removeClass("is-hidden");
      $(".tx-special__wrapper").removeClass("is-hidden");
      $(".tx-special__wrapper").removeClass("is-map");

  
      $(".osm-map").addClass("is-hidden");
      $(".tx-special__wrapper").removeClass("is-list is-tiles is-map");
      $(".section-product-listing .data-table").removeClass("is-list is-tiles");
      $(".section-product-listing .tx-special__products").removeClass("is-list is-tiles");

      $(".tx-special__wrapper").addClass("is-" + type);
      $(".section-product-listing .data-table").addClass("is-" + type);
      $(".section-product-listing .tx-special__products").addClass("is-" + type);
    }
  },

  setupOSMMap: function(geolocate = true) {
    var $map = $(".osm-map");

    for (var index = 0; index < LISTING.all_items.length; index++) {
      if (LISTING.all_items[index].coordinate == "") continue;
      var coordinates = LISTING.all_items[index].coordinate.split(",");
      var feature = new ol.Feature({
        geometry: new ol.geom.Point(
          ol.proj.fromLonLat([coordinates[1], coordinates[0]])
        ),
      });
      feature.setProperties({ ...LISTING.all_items[index], selectable: true });
      feature.setStyle(new ol.style.Style(null));
      LISTING.features.push({ id: LISTING.all_items[index].id, feature });
    }

    this.vectorLayer = new ol.layer.Vector({
      source: new ol.source.Vector({
        features: LISTING.features.map((f) => f.feature),
      }),
    });

    var view = new ol.View({
      center: ol.proj.fromLonLat([-7.839, 39.602]),
      zoom: 6,
    });

    APP.setupMap($map.get(0), view, false, geolocate);
    APP.map.addLayer(this.vectorLayer);

    var $popup = $("#popup");
    var popup = new ol.Overlay({
      element: $popup.get(0),
      positioning: "center-left",
      stopEvent: true,
      offset: [25, -15],
    });
    APP.map.addOverlay(popup);

    APP.map.on("click", function(evt) {
      console.log(1);
      var feature = APP.map.forEachFeatureAtPixel(evt.pixel, function(feature) {
        return feature;
      });
      if (LISTING.previousSelectedFeature != null) {
        LISTING.previousSelectedFeature.setStyle(LISTING.getStyle("default"));
        LISTING.previousSelectedFeature = null;
      }

      if (feature && _.get(feature.getProperties(), "selectable", false)) {
        console.log(feature);
        var coordinates = feature.getGeometry().getCoordinates();

        APP.map.getView().setCenter(coordinates);
        LISTING.previousSelectedFeature = feature;
        feature.setStyle(LISTING.getStyle("selected"));
        popup.setPosition(coordinates);
        $popup.html(
          LISTING.hb_template({ ...feature.getProperties(), style: "is-card" })
        );
        $popup.show();
      } else {
        $popup.hide();
      }
    });

    APP.map.on("pointermove", function(e) {
      // if (e.dragging) {
      //   $popup.hide();
      //   return;
      // }
      var pixel = APP.map.getEventPixel(e.originalEvent);
      var hit = APP.map.hasFeatureAtPixel(pixel);
      APP.map.getTarget().style.cursor = hit ? "pointer" : "";
    });
  },

  setOrderBy: function(order, dropitem) {
    $(dropitem)
      .parents(".dropdown")
      .addClass("is-selected");

    $(dropitem)
      .parents(".dropdown")
      .find(".drop-selected")
      .html($(dropitem).text());

    $(dropitem)
      .siblings()
      .removeClass("is-active");
    $(dropitem).addClass("is-active");

    this.orderBy = order;
    $(".dropdown.is-active").removeClass("is-active");
    LISTING.searchItems();
  },
};
